import * as Amplitude from '@amplitude/node';

// Hardcode
const client = Amplitude.init('88d74783341038daf82b65bdcd4641d1');

var amplitude = {
  trackEvent: trackEvent
};

async function hashEmail(email) {
  if (!email || typeof window === 'undefined' || !window.crypto?.subtle) {
    return undefined;
  }
  const encoded = new TextEncoder().encode(email.toLowerCase().trim());
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', encoded);
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

function getDeviceId() {
  try {
    let id = localStorage.getItem('amp_device_id');
    if (!id) {
      id = `web-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`;
      localStorage.setItem('amp_device_id', id);
    }
    return id;
  } catch (e) {
    return undefined;
  }
}

async function trackEvent(event_type, event_properties = {}, email = null) {
  const user_id = email ? await hashEmail(email) : undefined;
  // Return the logEvent promise so callers can await delivery before
  // navigating away (the upload is async and won't survive a hard redirect).
  return client.logEvent({
    event_type: event_type,
    user_id: user_id || undefined,
    device_id: getDeviceId(),
    event_properties: event_properties
  });
}

export default amplitude;
